module.exports = __webpack_public_path__ + "static/media/img_nav_mr2.1ac9628a.png";